var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useSelector } from 'react-redux';
import { initialDataSlice } from '../store/initialData/initialData.slice';
import { UTMUtils } from '../utils/UTM.utils';
export function useAudienceMarker(rules) {
    var audienceMarkerMeta = __assign({}, useSelector(initialDataSlice.selectors.getAudienceMarkerMeta));
    if (rules) {
        if (rules.ignoreCampaign) {
            delete audienceMarkerMeta.utm_campaign;
        }
        if (rules.ignoreSource) {
            delete audienceMarkerMeta.utm_source;
        }
        if (rules.ignorePlacementId) {
            delete audienceMarkerMeta.placementId;
        }
    }
    return UTMUtils.audienceMarkerUtils.makeAudienceMarker(audienceMarkerMeta);
}
